import PictureFill from 'picturefill';
import ImagesLoaded from 'imagesloaded';
import Classes from 'dom-classes';

function init () {
  PictureFill({
    elements: [ document.getElementsByTagName('img'), document.getElementsByTagName('picture'), document.getElementsByTagName('img[srcset]') ]
  });

  var burger = document.querySelector('.js-burger');
  var nav = document.querySelector('.js-nav');
  var body = document.querySelector('body');

  burger.addEventListener('click', (e) => {
    e.preventDefault();
    burger.classList.toggle('is-active');
    nav.classList.toggle('is-active');
    body.classList.toggle('is-disabled');
  });

  let imgLoad = ImagesLoaded(document.querySelectorAll('.media'));
  imgLoad.on('progress', handleLoadedProgress);
}

function handleLoadedProgress (idx, image) {
  Classes(image.img.parentElement).remove('is-loading');
}

if (window.addEventListener) {
  window.addEventListener('DOMContentLoaded', init);
} else {
  window.attachEvent('onload', init);
}



// WEBPACK FOOTER //
// ./src/js/index.js